import $ from "jquery";
import Gtm from "./GTM";

class ContactForm {
    constructor() {
        this.InitContactForm();
    }

    InitContactForm() {
        const $contactForms = $(".js-form-contact");
        const gtm = new Gtm();
        const formType = "contact_us";
        const $sentMessage = $(".sent-message");

        if ($contactForms.length === 0) {
            return;
        }
        $contactForms.each(function (_, form) {
            const $form = $(form);
            let started = false;
            const emailField = $(this).find("#form-contact-email");
            const messageField = $(this).find("#form-contact-message");
            const subjectField = $(this).find("#form-contact-subject");
            const errorMessageContainer = $(this).find(".js-error-message");

            const formStarted = () => {
                if (!started) {
                    started = true;
                    gtm.datalayerPush("form_start", {
                        form_type: formType,
                    });
                }
            };

            emailField.on("focus", formStarted);
            messageField.on("focus", formStarted);
            subjectField.on("focus", formStarted);

            $form.on("submit", function (ev) {
                const email = emailField.val() as string;
                const message = messageField.val() as string;
                const subject = subjectField.val() as string;

                if (
                    email &&
                    (email.length < 5 ||
                        !email.includes("@") ||
                        !email.includes("."))
                ) {
                    ev.preventDefault();
                    errorMessageContainer.text(
                        "Ange en giltig e-postadress, t.ex. namn@exempel.se",
                    );
                    errorMessageContainer.show();
                } else if (!email) {
                    ev.preventDefault();
                    errorMessageContainer.text("Ingen e-postadress ifylld");
                    errorMessageContainer.show();
                } else if (message.length === 0) {
                    ev.preventDefault();
                    errorMessageContainer.text("Fyll i ett meddelande");
                    errorMessageContainer.show();
                } else {
                    gtm.datalayerPush("form_submission", {
                        form_type: formType,
                        form_subject: subject,
                    });
                }
            });
        });

        if ($sentMessage.length) {
            $("html, body").animate(
                {
                    scrollTop: $($contactForms[0]).offset()!.top - 100,
                },
                0,
            );
        }
    }
}

export default ContactForm;
